module.exports = __webpack_public_path__ + "static/media/QR_closeIcon.a8056328.svg";